/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';

import * as React from 'react';
import { IInvoiceDetailsViewProps } from './invoice-details';

export const InvoiceDetailsView: React.FC<IInvoiceDetailsViewProps> = props => {
    const { header, products, paymentDetails, payInvoiceError } = props;

    return (
        <Module {...props.moduleProps}>
            {header}
            {products}
            {paymentDetails}
            {payInvoiceError}
        </Module>
    );
};

export default InvoiceDetailsView;